import { Button } from "components/ui/Button";
import { Sizes } from "components/ui/Loader";
import { getSizeValue } from "helpers/getSizesValue";
import { useMemo } from "react";

export interface StepButtonConfig {
  label: string;
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
  onClick?: () => void;
}

export interface StepPageConfig {
  prevConfig?: StepButtonConfig;
  nextConfig?: StepButtonConfig;
  containerSize?: Sizes | 'full'
  withoutPadding?: boolean
}

export interface StepPageProps extends StepPageConfig {
  children: React.ReactNode;
}

export const StepPage: React.FC<StepPageProps> = ({
  children,
  nextConfig,
  prevConfig,
  containerSize = 'full',
  withoutPadding = false
}) => {
  // Mapping des tailles vers les classes Tailwind appropriées
  //
  const containerSizeClasses = {
    [Sizes.xs]: 'max-w-xs mx-auto',
    [Sizes.sm]: 'max-w-sm mx-auto',
    [Sizes.base]: 'max-w-md mx-auto',
    [Sizes.md]: 'max-w-md mx-auto',
    [Sizes.lg]: 'max-w-lg mx-auto',
    [Sizes.xl]: 'max-w-xl mx-auto',
    [Sizes['2xl']]: 'max-w-2xl mx-auto',
    [Sizes['3xl']]: 'max-w-3xl mx-auto',
    [Sizes['4xl']]: 'max-w-4xl mx-auto',
    [Sizes['5xl']]: 'max-w-5xl mx-auto',
    full: 'w-full'
  };

  const sizeValue = getSizeValue(containerSize, containerSizeClasses)

  const renderButtons = useMemo(() => {
    return <div className="flex grow gap-4 justify-end">
      {
        prevConfig &&
        <Button
          size={Sizes.lg}
          outline
          className="bg-white"
          onClick={prevConfig.onClick}
        >
          {prevConfig.label}
        </Button>
      }
      {
        nextConfig &&
        <Button
          color="secondary"
          type="submit"
          size={Sizes.lg}
          onClick={nextConfig.onClick}
          disabled={nextConfig.disabled}
        >
          {nextConfig.label}
        </Button>
      }
    </div>

  }, [nextConfig, prevConfig])

  if (withoutPadding) {
    return (
      <div className={`${sizeValue} flex flex-col gap-6`}>
        {children}
        {renderButtons}
      </div>
    );
  }

  return (
    <div className={`${sizeValue} flex flex-col gap-6`}>
      <div className="p-6 w-full shadow border rounded-2xl bg-white">{children}</div>
      {renderButtons}
    </div>
  );
};
